import { CornermarkErrorFragment } from "@saleor/fragments/types/CornermarkErrorFragment";
import { commonMessages } from "@saleor/intl";
import { CornerMarkErrorCode } from "@saleor/types/globalTypes";
import { defineMessages, IntlShape } from "react-intl";

import commonErrorMessages from "./common";

const messages = defineMessages({
  alreadyExists: {
    defaultMessage: "A product with this SKU already exists"
  },
  duplicatedInputItem: {
    defaultMessage: "Variant with these attributes already exists"
  },
  nameAlreadyTaken: {
    defaultMessage: "This name is already taken. Please provide another."
  }
});

function getCornermarkErrorMessage(
  err: Omit<CornermarkErrorFragment, "__typename"> | undefined,
  intl: IntlShape
): string {
  if (err) {
    switch (err.code) {
      case CornerMarkErrorCode.ALREADY_EXISTS:
        return intl.formatMessage(messages.alreadyExists);
      case CornerMarkErrorCode.DUPLICATED_INPUT_ITEM:
        return intl.formatMessage(messages.duplicatedInputItem);
      case CornerMarkErrorCode.GRAPHQL_ERROR:
        return intl.formatMessage(commonErrorMessages.graphqlError);
      case CornerMarkErrorCode.REQUIRED:
        return intl.formatMessage(commonMessages.requiredField);
      case CornerMarkErrorCode.INVALID:
        return intl.formatMessage(commonErrorMessages.invalid);
      case CornerMarkErrorCode.UNIQUE:
        return intl.formatMessage(messages.nameAlreadyTaken);
      default:
        return intl.formatMessage(commonErrorMessages.unknownError);
    }
  }

  return undefined;
}

export default getCornermarkErrorMessage;
